import { render } from "./SimpleFrame.vue?vue&type=template&id=5643ceb2"
import script from "./SimpleFrame.vue?vue&type=script&lang=js"
export * from "./SimpleFrame.vue?vue&type=script&lang=js"

import "./SimpleFrame.vue?vue&type=style&index=0&id=5643ceb2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__